import * as React from 'react';
import { connect } from 'react-redux';
import { KP_COPYRIGHT, NAM_KP_FSP, SA_KP_FSP_LINE1, SA_KP_FSP_LINE2 } from '../../constants/internationalization';
import './SignInSignUp-SharedCSS.css';

class SignInSignUpSharedFooter extends React.Component<any, any> {
    public render() {
        return (
            <>
                <div className="login-signup-footer-container-outer">
                    <div className="login-signup-footer-container-inner">
                        <span>{this.props.profile.countryId === 157 ? NAM_KP_FSP : SA_KP_FSP_LINE1}</span>
                        <br />
                        {this.props.profile.countryId !== 157 &&
                            <>
                            <span>{ SA_KP_FSP_LINE2 }</span>
                            <br />
                            </>
                        }
                        <span className="login-signup-footer-copyright">&copy; {KP_COPYRIGHT}</span>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(SignInSignUpSharedFooter);